import { useEffect, useState } from "react";

export default function Comment( { id, blog } ) {
  const [name, setName] = useState("");
  const [comment, setComment] = useState("");

  const [comments, setComments] = useState([]);

  // Function to post the comment
  const postComment = async (name, comment, id, blog) => {
    try {
      const response = await fetch("https://imajin.dev/api/create-a-page", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
            name,
            comment,
            id,
            blog
        }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      console.log("Comment posted successfully");
    } catch (error) {
      console.error("Error posting comment:", error.message);
    }
  };

  const handleSubmit = () => {

    if ( !name || !comment ) {
      alert("Both fields are required");
      return;
    }

    console.log(blog);

    postComment(name, comment, id, blog);
    setComment("");

  };

   //fetch comments
   const fetchComments = async ( id ) => {
    
    try {
      const response = await fetch("https://imajin.dev/api/query-a-database-comment", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id
        }),
      });
  
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
  
      const result = await response.json();

      // console.log(result);
      setComments(result);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect( () => {
    fetchComments( id );
  }, [comments])

  return (
    <div style = { { backgroundColor : 'var(--black2)', borderTop : "1px solid var(--black4)", borderBottom : "1px solid var(--black4)" } }>
      <div style = { { paddingTop : "0px", paddingBottom : "80px" } } className = "page">
      <br/>
      <p style = { { color : "var(--black80)"} }>Comment?</p>
      <br/>

      <input
        type = "text"
        placeholder = "Name"
        value = { name }
        onChange = { (e) => setName(e.target.value) }
      />
      <textarea
        type = "text"
        placeholder = "Comment cannot be edited or deleted"
        autoComplete = "off"
        value = { comment }
        onChange = { (e) => setComment(e.target.value) }
      />

      <div style = { { display : "flex", justifyContent : "flex-end" } }>
        <button onClick = { handleSubmit } className = "commentButton">
          Leave a comment
        </button>
      </div>

      {/* READ COMMENTS */}
      <div className = "hr"/>

      <p>Comments ({ comments.length })</p>

      { comments.map( (item, index) => (
        <div className = "commentContainer" key = { index }>
          <span className = "bubble1"/>
          <span className = "bubble2"/>

          <div style={ { display : "flex", flexDirection : "row", gap : "4px" } }>
            <p className = "tiny">{ item.properties.Name.title[0].plain_text } </p>
            <p className = "tiny" style = { { color : "var(--black40)"} }>says,</p>
          </div>

          <pre>{ item.properties.Comment.rich_text[0].plain_text }</pre>
          
          <p className = "meta">{ item.properties.Date.formula.string }</p>
        </div>
      ))}

    </div>
    </div>
  );
}